module.exports = "//static.hsappstatic.net/connect-dot-com-ui/static-1.468/html/third-party-cookie-test.html"